import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';
import { Types, Creators } from 'store/ducks/attachment/update';
import { callApi } from 'store/sagas/auth';
import Notifications from 'react-notification-system-redux';

function* getUploadAttachment({ id, file }) {
  const data = new FormData();
  data.append('file', file);
  const request = call(api.post, `/v1/admin/attachments/${id}/file`, data);
  const response = yield call(callApi, request);
};

function* getEditAttachment({ payload }) {
  try {
    const { id, name, slug, file, description, activity_id, status } = payload;
    const request = call(api.put, `/v1/admin/attachments/${id}`, {
      name,
      slug,
      description,
      activity_id,
      status,
    });
    const response = yield call(callApi, request);
    if (file instanceof File) {
      yield getUploadAttachment({
        id,
        file,
      });
    }
    yield put(Creators.getAttachmentUpdateSuccess(response.data));
    yield put(Notifications.success({ title: 'Edição concluida com sucesso' }));
  } catch (err) {
    yield put(Creators.getAttachmentUpdateFailure('Erro ao buscar na API'));
  }
}

export default function* attachmentSaga() {
  yield all([takeLatest(Types.GET_UPDATE_REQUEST, getEditAttachment)]);
}
